import { Table } from '@unifyapps/ui/components/Table';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import CssVarsProvider from '../../../../../style/src/joy/CssVariableProvider';

interface TableRendererProps {
  children: ReactNode;
  overflowContainerClassName?: string;
}

export function TableRenderer({ children, overflowContainerClassName }: TableRendererProps) {
  return (
    <div className="relative w-full group/md-table">
      <div className={clsx('w-full overflow-auto not-prose', overflowContainerClassName)}>
        {/* overriding attribute so that joy's theme colors will be applied to table elements since we are using joy table */}
        <CssVarsProvider attribute="data-color-scheme">
          <Table>{children}</Table>
        </CssVarsProvider>
      </div>
    </div>
  );
}
